import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Comment from '../comment'
import LayOut from '../layOut'
import { login } from '../../../store/action'

const LogIn = () => {
  const [mobile, setMobile] = useState('')
  const [password, setPassword] = useState('')
  const _token = useSelector(state => state.reducer.token)
  const [token, setToken] = useState()

  const dispatch = useDispatch()
  const navigate = useNavigate()

  useEffect(
    () => {
      setToken(_token)
    },
    [_token]
  )

  const loginHandler = async e => {
    e.preventDefault()
    dispatch(login(mobile, password))

    setMobile('')
    setPassword('')
  }

  useEffect(
    () => {
      const listener = event => {
        if (event.code === 'Enter') {
          event.preventDefault()
          loginHandler(event)
        }
      }
      document.addEventListener('keydown', listener)
      return () => {
        document.removeEventListener('keydown', listener)
      }
    },
    [mobile, password, loginHandler]
  )

  if (token) {
    return <LayOut />
  }
  return (
    <div className="font-IRANSansWeb mx-auto  pt-10   ">
      <div className=" w-[1000px] mx-auto caret-transparent screen800:w-[400px] screen400:w-[300px] ">
        <div className="flex flex-row  justify-between  mt-12 clear-both px-8 w-full screen800:justify-center ">
          <form className="bg-gradient-to-t from-[#faf838]  via-[#faf738a4] to-gray-600
           mt-8 rounded-xl py-8  w-[350px]
            text-center  text-[15px]   place-items-center font-bold
            screen800:w-[300px] screen800:py-0 screen800:mt-1
            ">
            <br />
            <input
              style={{ direction: '' }}
              className="my-4 w-[80%] bg-white text-gray-600 rounded-xl pl-3 py-2 border-[#ed1c24]0 placeholder-gray-400
             focus:outline-none focus:placeholder-white "
              type="text"
              name="mobile"
              placeholder="نام کاربری"
              value={mobile}
              onChange={e => {
                setMobile(e.target.value)
              }}
            />
            <br />

            <input
              style={{ direction: '' }}
              className="my-4 w-[80%] bg-white text-gray-600 rounded-xl pl-3 py-2 placeholder-gray-400
             focus:outline-none focus:placeholder-white"
              type="password"
              name="password"
              placeholder="کلمه عبور"
              value={password}
              onChange={e => {
                setPassword(e.target.value)
              }}
            />

            <div style={{ textAlign: 'center', margin: '7px 0 ' }}>
              <button
                disabled={!mobile || !password}
                onClick={loginHandler}
                className=" rounded-xl px-10 text-center  pb-2 py-1 bg-white mt-36 font-extrabold  text-gray-600 hover:cursor-pointer
                screen800:mb-8 screen800:mt-24 disabled:bg-gray-400 disabled:text-[#faf838]  disabled:cursor-not-allowed
                "
              >
                ورود
              </button>

              <br />
            </div>
          </form>

          <div
            style={{ direction: 'rtl' }}
            className=" pl-12 mt-8 text-justify font-extrabold w-[500px]
              text-[#faf838] leading-tight text-lg
              screen800:hidden
              "
          >
            خوش آمدید
            <br />
            <span className="text-sm">
              نام کاربری و کلمه ی عبور خود را وارد کنید .
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LogIn
